export default __webpack_public_path__ + "static/media/steve.313216bc.png";